export default __webpack_public_path__ + "static/media/attic_D612-2X15-DF-REI60.0842a556.jpg";